
export function safeLocalStorage(key, value) {
  try {
    if (value !== undefined) {
      localStorage.setItem(key, value);
      return true;
    }
    return localStorage.getItem(key);
  } catch (e) {
    
    return value !== undefined ? false : null;
  }
}

export function safeLocalStorageRemove(key) {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
}

export default safeLocalStorage;
